import { css as t } from "../stitches.config.es.js";
const n = t({
  fontFamily: "Poppins",
  fontWeight: 600,
  background: "-webkit-linear-gradient(90deg, #16234c, #e03e52 80%)",
  backgroundClip: "border-box",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent"
}), o = t({
  fontSize: "75%"
}), i = t({
  verticalAlign: "top"
});
export {
  o as wtnDecimalStyles,
  i as wtnMarkStyles,
  n as wtnStyles
};
//# sourceMappingURL=Wtn.styles.es.js.map
